/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as ButtonSizes } from './button-sizes.story';
export { default as ButtonLeadingIcon } from './button-leading-icon.story';
export { default as ButtonFluid } from './button-fluid.story';
export { default as ButtonVariants } from './button-variants.story';
export { default as ButtonLoading } from './button-loading.story';
export { default as ButtonDisabled } from './button-disabled.story';
export { default as ButtonFloating } from './button-floating.story';
export { default as ButtonRunningCancel } from './button-running-cancel.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import ButtonDisabledSrcRaw from './button-disabled.story?raw';
import ButtonFloatingSrcRaw from './button-floating.story?raw';
import ButtonFluidSrcRaw from './button-fluid.story?raw';
import ButtonLeadingIconSrcRaw from './button-leading-icon.story?raw';
import ButtonLoadingSrcRaw from './button-loading.story?raw';
import ButtonRunningCancelSrcRaw from './button-running-cancel.story?raw';
import ButtonSizesSrcRaw from './button-sizes.story?raw';
import ButtonVariantsSrcRaw from './button-variants.story?raw';

export const ButtonSizesSrc = removeLicenseHeader(ButtonSizesSrcRaw);
export const ButtonLeadingIconSrc = removeLicenseHeader(
  ButtonLeadingIconSrcRaw,
);
export const ButtonFluidSrc = removeLicenseHeader(ButtonFluidSrcRaw);
export const ButtonVariantsSrc = removeLicenseHeader(ButtonVariantsSrcRaw);
export const ButtonLoadingSrc = removeLicenseHeader(ButtonLoadingSrcRaw);
export const ButtonDisabledSrc = removeLicenseHeader(ButtonDisabledSrcRaw);
export const ButtonFloatingSrc = removeLicenseHeader(ButtonFloatingSrcRaw);
export const ButtonRunningCancelSrc = removeLicenseHeader(
  ButtonRunningCancelSrcRaw,
);
